import 'owl.carousel';

export default function() {
    $('.trending-slider').owlCarousel({
        rtl: herald_js_settings.rtl_mode === "true",
        loop: true,
        autoWidth: false,
        items: herald_js_settings.trending_columns,
        nav: false,
        center: false,
        fluidSpeed: 100,
        margin: 20,
        autoplay: true,
        autoplayHoverPause: true,
        autoplayTimeout: 2500
    });
}
